import React from 'react';

import { gettext } from '@adjust/dashboard-core/lib/utils/localization';

const roleList = [
  {
    class: 'role-admin',
    name: gettext('role.admin'),
    description: gettext('users.about-permissions.admin-role'),
  },
  {
    class: 'role-editor',
    name: gettext('role.editor'),
    description: gettext('users.about-permissions.editor-role'),
  },
  {
    class: 'role-reader',
    name: gettext('role.reader'),
    description: gettext('users.about-permissions.reader-role'),
  },
  {
    class: 'role-custom',
    name: gettext('role.custom'),
    description: gettext('users.about-permissions.custom-role'),
  },
];

export const AboutPermissions = () => (
  <div className="content content-panel content-about-permissions flex-one flex-box-column">
    <div className="content-title-box without-background">
      <div className="flex-auto">
        <h3 className="content-heading">{t('label.about-permissions')}</h3>
      </div>
    </div>

    <div className="sidebar-view flex-one flex-box-column">
      <div className="content content-panel content-setup flex-one flex-box-row relative">
        <div className="flex-one flex-box-column">
          <div className="content-inner flex-one flex-box-column scroll-container">
            <div className="panel-content">
              {roleList.map(role => (
                <div className="panel-section" key={role.class}>
                  <div className={`role-tag ${role.class}`}>{t(role.name)}</div>
                  <p className="info small">{t(role.description)}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);
